import Masonry from 'masonry-layout';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
import 'photoswipe/style.css';
import photoSwipe from 'photoswipe';
import $ from 'jquery';

const diaporama = (function () {
  function _init() {
    const elem = document.querySelector('.block-diaporama .field--field-images');
    const closeIcon = '<svg aria-hidden="true" class="pswp__icn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1.195" y="1.287" width="37.607" height="37.426" rx="18.713" fill="#FDFCF5"/><path stroke="#9A0B28" stroke-width="2" d="m9.902 8.793 21.214 21.213M8.883 29.793 30.096 8.58"/></svg>';
    if (elem) {
      $(window).on('load', function () {
        // eslint-disable-next-line
        const msnry = new Masonry(elem, {
          percentPosition: true,
          horizontalOrder: true,
        });
      });

      const lightbox = new PhotoSwipeLightbox({
        gallery: '#pswp-gallery',
        children: '.pswp-gallery__item',
        showHideAnimationType: 'fade',
        zoomAnimationDuration: 0,
        bgOpacity: 1,
        pswpModule: () => photoSwipe,
        closeSVG: closeIcon
      });

      // eslint-disable-next-line
      const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
        captionContent: (slide) => {
          let captionWrapper = slide.data.element.querySelector('img').closest('.paragraph--view-mode--block-2-images').querySelector('.text-wrapper');
          if (captionWrapper) {
            return captionWrapper.innerHTML;
          }
        }
      });

      lightbox.init();
    }

    // Open each image individually
    const lightboxBlazyImage = new PhotoSwipeLightbox({
      gallery: '.blazy--field-image--default a',
      showHideAnimationType: 'fade',
      zoomAnimationDuration: 0,
      bgOpacity: 1,
      pswpModule: () => photoSwipe,
      closeSVG: closeIcon
    });

    // eslint-disable-next-line
    const captionImagePlugin = new PhotoSwipeDynamicCaption(lightboxBlazyImage, {
      captionContent: (slide) => {
        let captionWrapper = slide.data.element.querySelector('img').closest('.image-content').querySelector('.text-wrapper');
        if (captionWrapper) {
          return captionWrapper.innerHTML;
        }
      }
    });

    lightboxBlazyImage.init();
  }

  return {init: _init};
})();

export default diaporama;
